import { createTheme, darken, Theme as ITheme } from "@mui/material/styles";

// MOVE brand colours
// Navy:      #1A2B6E
// Orange:    #F5924E
// Red-Orange:#E8451A

const Theme: ITheme = createTheme(
	{
		components: {
			MuiAppBar: {
				styleOverrides: {
					root: {
						backgroundColor: "#FFFFFF",
						boxShadow: "none",
						color: "inherit"
					}
				}
			},
			MuiAutocomplete: {
				styleOverrides: {
					inputRoot: {
						padding: 0
					}
				}
			},
			MuiButton: {
				styleOverrides: {
					root: {
						textTransform: "none"
					},
					containedPrimary: {
						"&:hover": {
							backgroundColor: darken("#1A2B6E", 0.15)
						}
					},
					containedSecondary: {
						"&:hover": {
							backgroundColor: darken("#F5924E", 0.1)
						}
					},
					outlinedPrimary: {
						borderWidth: "2px",
						borderColor: "#1A2B6E",
						"&:hover": {
							borderWidth: "2px",
							borderColor: "#1A2B6E"
						}
					}
				}
			},
			MuiCssBaseline: {
				styleOverrides: {
					body: {
						backgroundColor: "#F7F7F7"
					}
				}
			},
			MuiFormControl: {
				styleOverrides: {
					root: {
						backgroundColor: "#FFFFFF",
						borderColor: "#F7F7F7"
					}
				}
			}
		},
		palette: {
			primary: {
				main: "#1A2B6E",
				dark: darken("#1A2B6E", 0.15),
				light: "#E8EAEF"
			},
			secondary: {
				main: "#F5924E",
				dark: "#E8451A",
				light: "#FDE8D8"
			},
			background: {
				default: "#F5F7F8",
				paper: "#FFFFFF"
			},
			text: {
				primary: "#000000",
				secondary: "#1A2B6E"
			}
		},
		spacing: (factor: number) => `${0.25 * factor}rem`,
		typography: {
			allVariants: {
				fontFamily: "Inter, sans-serif"
			}
		}
	},
	{
		portalFramework: {
			pages: {
				login: {
					backgroundContainer: {}
				}
			}
		}
	}
);

export default Theme;
